/**
 * Compact CTA section between Collection and VIP form.
 * Replaces the previous testimonials cards with a single, centered call-to-action.
 */
export const Testimonials = () => {
  const goToVip = () => {
    document.querySelector("#vip")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="vozes"
      data-testid="section-testimonials"
      className="relative bg-kora-forest py-16 md:py-24"
      style={{ backgroundColor: "#1C3A2F" }}
    >
      <div className="max-w-2xl mx-auto px-6 text-center reveal">
        <button
          type="button"
          data-testid="vozes-cta"
          onClick={goToVip}
          className="btn-outline-hero"
        >
          Quero entrar na Lista VIP
          <span className="arrow">→</span>
        </button>
      </div>
    </section>
  );
};
